import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'



export default function TrainerAccountInfoComponent({ handleBasicFormChange,handleInnerFormChange, selectedTrainers, accounts }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

 <InputContainer
              label="TrainerCode"
              name="TrainerCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Account.TrainerCode',
                  selectedTrainers?.TrainerCode
                )
              }}
              type="text"
              value={selectedTrainers?.Account?.TrainerCode}
            />

            <InputContainer
              label="Person Account"
              name="IsPersonAccount"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'Account.IsPersonAccount',
                  selectedTrainers?.Account
                )
              }}
              type="checkbox"
              value={selectedTrainers?.Account?.IsPersonAccount}
            />

        
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Account.Name',
                  selectedTrainers?.Account
                )
              }}
              type="text"
              value={selectedTrainers?.Account?.Name}
            />

            <InputContainer
              label="Number Of Vehicles"
              name="NumberOfVehicles"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Account.NumberOfVehicles',
                  selectedTrainers?.Account
                )
              }}
              type="number"
              value={selectedTrainers?.Account?.NumberOfVehicles}
            />







          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Account Info"
      />

    </>
  )
}